import React, { PropsWithChildren } from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';

class ScrollToTop extends React.Component<PropsWithChildren<RouteComponentProps>> {
  componentDidUpdate(prevProps: RouteComponentProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default compose(withRouter)(ScrollToTop);
